<template>
  <div class="Kanit">
    <slot name="header"></slot>
    <div class="text-center mt-8">
      <img height="100px" src="@/assets/logo.png" />
    </div>
    <div class="px-10 pt-7 mx-auto" style="max-width: 500px">
      <ValidationObserver ref="observer">
        <ValidationProvider
          name="เบอร์โทรศัพท์"
          :rules="'required|thai_phonenumber'"
          v-slot="{ errors }"
        >
          <custom-input
            outlined
            name="email"
            color="primary"
            prepend-inner-icon="mdi-account"
            placeholder="เบอร์โทรศัพท์"
            background-color="#eee"
            v-model="input.username"
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          name="รหัสผ่าน"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            outlined
            color="primary"
            prepend-inner-icon="mdi-lock"
            placeholder="รหัสผ่าน"
            background-color="#eee"
            v-model="input.password"
            :hide-details="!errors.length"
            type="password"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <div @click="forgetPassword" class="text-right mt-3">
          <a>ลืมรหัสผ่าน</a>
        </div>
      </ValidationObserver>
      <div class="text-center mt-3">
        <v-btn :loading="saveloading" @click="login" color="primary"
          >Login</v-btn
        >
      </div>
      <div class="grey--text text-center mt-5">
        หากยังไม่ได้สมัครสมาชิก
        <span @click="query.view = 'Register'" class="primary--text"
          >สมัครเลย</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      saveloading: false,
      input: {
        username: "",
        password: "",
      },
    };
  },
  created() {
    this.$store.state.headertext = "";
  },
  methods: {
    forgetPassword() {
      this.query.view = "ForgetPassword";
    },
    async login() {
      if (await this.$refs.observer.validate()) {
        var data = {
          liffuserid: this.profile.userId,
          userid: this.userid,
          pageid: this.query.pageid,
          username: this.input.username,
          password: this.input.password,
        };
        this.saveloading = true;
        axios
          .post(this.serverUrl + "yasale/login", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xx",
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.$store.state.member = response.data.data[0];
              if (this.$store.state.redirectview) {
                this.query.view = this.$store.state.redirectview;
              } else {
                this.query.view = "ScanIMEI";
              }
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>